export default {
      id: "icon-arrow-down-2-usage",
      viewBox: "0 0 41.62 28.12",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-arrow-down-2",
      toString: function () {
        return this.url;
      }
    }